var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"waves-container",class:{'animate-red':_vm.color === 'redBlinking',
              'small':_vm.size === 'small'}},[_c('canvas',{ref:"waveCanvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }